import React from 'react';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import Family from '../../../assets/images/family-tree-svgrepo-com.svg'
import Location from '../../../assets/images/location-svgrepo-com.svg'
import youtube from '../../../assets/images/youtube-svgrepo-com.svg'
import wikipedia from '../../../assets/images/wikipedia-svgrepo-com.svg'
import './index.scss';

const PoemTag = ({ visible, onClose, data,title, openAudioPlayer }) => {
    const { t } = useTranslation();

    return (
        <Modal
            visible={visible}
            onCancel={onClose}
            footer={null}
            closable={false}
            className="__info_model"
        >
            <div className="__info_header" style={{ marginBottom: 0 }}>
                <h1>{title}</h1>
                <CloseOutlined onClick={onClose} style={{ cursor: 'pointer' }} />
            </div>

            <div className='__info_model_content'>
            {data?.map((item, index) => (
                <div className="__single_tag_sec" key={index}>
                    <h1
                        className="__tag_head"
                        style={{
                            borderTopColor: `#${item.categoryColour}`,
                        }}
                    >
                        {item.name}
                    </h1>

                    <p className="__tag_category">
                        {t('CATEGORY_NAME')} : <a>{item.categoryName}</a>
                    </p>

                    <p className="__tag_icon_set">
                        {item.familyTree && (
                            <a href={item.familyTree} target="_blank" rel="noopener noreferrer">
                                <img src={Family} alt="Tree" />
                                {/* <img src="./../../assets/images/family-tree-svgrepo-com.svg" alt="Tree" /> */}
                            </a>
                        )}
                        {item.latitude && (
                            <a>
                                <img src={Location} alt="Location" />
                            </a>
                        )}
                        {item.youtubeURL && (
                            <a href={item.youtubeURL} target="_blank" rel="noopener noreferrer">
                                <img src={youtube} alt="Youtube" />
                            </a>
                        )}
                        {item.wikipediaURL && (
                            <a href={item.wikipediaURL} target="_blank" rel="noopener noreferrer">
                                <img src={wikipedia} alt="Wiki" />
                            </a>
                        )}
                        {/* {item.audios?.length > 0 && (
              <a onClick={() => openAudioPlayer(item.audios)}>
                <img src="./../../assets/images/audio-svgrepo-com.svg" alt="Audio" />
              </a>
            )} */}
                    </p>

                    <p
                        className="__info_descr"
                        dangerouslySetInnerHTML={{ __html: item.description }}
                    />

                    {item.photos?.length > 0 && (
                        <div className="__tag_img_sec">
                            {item.photos.map((img, idx) => (
                                <img src={img.photo} alt="" key={idx} />
                            ))}
                        </div>
                    )}
                </div>
            ))}
            </div>
        </Modal>
    );
};

export default PoemTag;
